import {useState, useEffect} from 'react'
import {Form, Button} from 'react-bootstrap'
import Template from "../components/Template"
import {useSelector, useDispatch} from 'react-redux'
import {userUpdate, userRemove, userLogout} from '../actions/userActions'
import {USER_UPDATE_UNSET} from '../constants/userConstant'
import Popup from '../components/PopupMessage'
import Loader from '../components/Loader'
import { useHistory } from 'react-router-dom'

const Profile = () => {
    const {user:{data}} = useSelector(state => state.login)
    const {loading, error, success} = useSelector(state => state.update)
    const {loading:loading_r, error:error_r, success:success_r} = useSelector(state => state.remove)
    const history = useHistory()
    const [editPass, setEditPass] = useState(false)
    const dispatch = useDispatch()
    const [isNotMatch, setIsNotMatch] = useState(false)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const linkedMemberId = data.memberId && (data.memberId._id || data.memberId)
    const initials = `${data.firstName ? data.firstName[0] : ''}${data.lastName ? data.lastName[0] : ''}`
    const isPublicAccount = !!data.isPublicAccount
    const roleLabel = data.isAdmin ? 'مدير النظام' : data.isCoAdmin ? 'مساعد مدير' : isPublicAccount ? 'حساب عام للتصفح فقط' : 'عضو'

    const editHandler = e => {
        e.preventDefault()
        if(password !== confirmPassword) return setIsNotMatch(true)
        const data = {firstName, lastName, email, phone}
        if(password) data.password = password
        dispatch(userUpdate(data))
    }

    const removeUserHandler = e => {
        e.preventDefault()
        const isConfirm = window.confirm('هل أنت متاكد من حذف الحساب')
        if(isConfirm){
          dispatch(userRemove())
        }
    }
    
    useEffect(() => {
       if(data) {
          setFirstName(data.firstName)
          setLastName(data.lastName)
          setEmail(data.email)
          setPhone(data.phone)
       }
       success_r && history.push('/')
    },[data, history, success_r])
    return (
        <Template>
            {isNotMatch && <Popup danger passHandler={() => setIsNotMatch(false)}><p>كلمة المرور غير مطابقة من فضلك حاول مرة أخرى</p></Popup>}
            {error && <Popup danger passHandler={() => dispatch({type:USER_UPDATE_UNSET})}><p>{error}</p></Popup>}
            {error_r && <Popup danger><p>{error_r}</p></Popup>}
            {success && <Popup success passHandler={() => dispatch({type:USER_UPDATE_UNSET})}><p>تم تعديل البيانات بنجاح</p></Popup>}
            {loading_r && <Popup danger><p>...جارى حذف الحساب</p></Popup>}
            {loading 
            ? <Popup><Loader/></Popup>
            :<div className='profile'>
                <section className='profile__summary'>
                    <div className='profile__avatar'>{initials || <i className='fas fa-user-alt'></i>}</div>
                    <div>
                        <h2>{data.firstName} {data.lastName}</h2>
                        <p>{roleLabel}</p>
                    </div>
                    <div className='profile__quickActions'>
                        {linkedMemberId && <Button
                            variant="light"
                            onClick={() => history.push(`/info/${linkedMemberId}`)}
                        >
                            بياناتي في شجرة العائلة
                        </Button>}
                        <Button variant='secondary' onClick={() => dispatch(userLogout())}>
                            <i className="fas fa-sign-out-alt"></i> تسجيل الخروج
                        </Button>
                    </div>
                </section>

                <section className='profile__details'>
                    <div className='profile__info'>
                        <h3>معلومات الحساب</h3>
                        <ul>
                            <li><span>البريد الإلكتروني</span><strong>{data.email}</strong></li>
                            <li><span>رقم الجوال</span><strong>{data.phone}</strong></li>
                            <li><span>الملف العائلي</span><strong>{linkedMemberId ? 'مرتبط بعضو' : 'غير مرتبط'}</strong></li>
                            <li><span>حالة الحساب</span><strong>{data.isActive ? 'مفعل' : 'بانتظار التفعيل'}</strong></li>
                            {isPublicAccount && <li><span>نوع الحساب</span><strong>مشاهدة فقط</strong></li>}
                        </ul>
                    </div>

                    <Form className='profile__form' onSubmit={(e) => editHandler(e)}>
                        <h3>تعديل البيانات</h3>
                        <div className='profile__grid'>
                            <Form.Group controlId="formBasicFirstName">
                                <Form.Label>الإسم الأول</Form.Label>
                                <Form.Control
                                type="text"
                                value={firstName}
                                required
                                disabled={isPublicAccount}
                                onChange={({target:{value}}) => setFirstName(value)}/>
                            </Form.Group>

                            <Form.Group controlId="formBasicLastName">
                                <Form.Label>الإسم الأخير</Form.Label>
                                <Form.Control
                                type="text"
                                value={lastName}
                                required
                                disabled={isPublicAccount}
                                onChange={({target:{value}}) => setLastName(value)}/>
                            </Form.Group>

                            <Form.Group controlId="formBasicEmail">
                                <Form.Label>البريد الإلكترونى</Form.Label>
                                <Form.Control
                                type="email"
                                value={email}
                                required
                                disabled={isPublicAccount}
                                onChange={({target:{value}}) =>setEmail(value) }/>
                            </Form.Group>

                            <Form.Group controlId="formBasicPhone">
                                <Form.Label>الجوال</Form.Label>
                                <Form.Control
                                type="tel"
                                value={phone}
                                required
                                disabled={isPublicAccount}
                                onChange={({target:{value}}) => setPhone(value) }/>
                            </Form.Group>
                        </div>

                        {!isPublicAccount && <button className='profile__passwordToggle' onClick={(e) => {
                            e.preventDefault()
                            setEditPass(!editPass)
                            setPassword('')
                            setConfirmPassword('')
                        }}>
                            {editPass ? 'إخفاء تغيير كلمة المرور' : 'تغيير كلمة المرور'}
                        </button>}

                        {editPass && <div className='profile__grid'>
                            <Form.Group controlId="formBasicPassword">
                                <Form.Label>كلمة المرور الجديدة</Form.Label>
                                <Form.Control
                                type="password"
                                placeholder="كلمة المرور"
                                required
                                onChange={({target:{value}}) => setPassword(value)}/>
                            </Form.Group>

                            <Form.Group controlId="formBasicPasswordConfirm">
                                <Form.Label>تأكيد كلمة المرور</Form.Label>
                                <Form.Control
                                type="password"
                                placeholder="تأكيد كلمة المرور"
                                required
                                onChange={({target:{value}}) => setConfirmPassword(value)}/>
                            </Form.Group>
                        </div>}

                        <div className='profile__actions'>
                            {!isPublicAccount && <Button variant="primary" type="submit">حفظ التعديلات</Button>}
                            {!isPublicAccount && <Button variant='danger' onClick={removeUserHandler}>حذف الحساب</Button>}
                        </div>
                    </Form>
                </section>
            </div>}
        </Template>
    )
}

export default Profile
